import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <p>This table will help explain your rating in more detail.</p>


                                            <table className="ilead_v_sport tablesrink uiheading" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="20%">Score
                                                    </th>
                                                    <th align="left" valign="top" width="20%">Category</th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="60%">Implication
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>&gt;115 </p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>Distractable</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="60%"><p>You’ll get bored easily. Try to identify
                                                        three or four of
                                                        the answers on the previous page that really stand out
                                                        for you. Think about what really excites you and what
                                                        keeps you doing that activity. Maybe you need to have
                                                        variety in your life in order to keep you stimulated or
                                                        be working on several things at the same time. Think
                                                        about how you sustain your momentum at work and
                                                        focus on completing your work.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>100-115 </p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>The Plate Spinner</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="60%"><p>You’re likely to get bored with certain
                                                        things and will
                                                        want to keep busy. Look back over your responses
                                                        and note down where you agreed with the statements.
                                                        Look for common themes. You’re probably someone
                                                        who likes to have more than one activity happening at
                                                        the same time and will stick to several things rather
                                                        than concentrate your efforts on one. Think about your
                                                        work environment and how you work to meet
                                                        deadlines.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>85-100</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="20%"><p>Racing Drivers</p>
                                                    </td>
                                                    <td className="darkgreen" align="left" valign="top"
                                                        width="60%"><p>You’re not likely to get bored easily.
                                                        Like a Formula
                                                        One racer, you’ll be able to sustain momentum with
                                                        only a few pit stops. Think about how you can use your
                                                        ability to stick with a task to help you in the areas
                                                        where you may get bored more easily. Try to bear in
                                                        mind how flexible you need to be in your current work
                                                        environment and how you prefer to work.</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>&lt;85</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="20%"><p>The Power Station</p>
                                                    </td>
                                                    <td className="lightgreen" align="left" valign="top"
                                                        width="60%"><p>You’re not likely to get bored at all.
                                                        Lucky you! You’re
                                                        probably able to stick with a task or activity when
                                                        others around you may give up or get diverted.
                                                        Consider how you work when you have a number of
                                                        activities to complete with limited time and resources.
                                                        Can you adapt your style to multitask, or prioritise and
                                                        focus on doing one thing at a time?</p>
                                                    </td>
                                                </tr>

                                                </tbody>
                                            </table>
                                            <div className="border_subtitle">Maintain momentum in others</div>
                                            <p>Consider how ‘results-orientated’ you are with your team, and
                                                list the methods you use to motivate
                                                and enthuse your direct reports. Identify the business outcomes
                                                you’re focused on to sustain and
                                                increase their drive, enthusiasm and effort.</p>
                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>NEXT STEPS
                                            </div>
                                            <p>Now you know how to maintain your momentum, here are a few
                                                suggestions about what to
                                                do next.</p>
                                            <div className="border_subtitle">Gather feedback on existing
                                                performance
                                            </div>
                                            <p>You may find it useful to ask for formal or informal feedback, to
                                                understand how other people
                                                perceive you and get advice about where you can make
                                                modifications or improvements. You can
                                                also use this information to manage people’s future expectations
                                                about your approach and ability
                                                to deliver. </p>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page10')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>


                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}